import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { Unity, useUnityContext } from "react-unity-webgl";
import envConfig from "../config.json";
import { Progress , Spin} from "antd";
import { useTheme } from "../components/ThemeContext";

import NavigationMessage from "../components/NavigationMessage";

/**
 * This component is used to handle the POI functionality
 */
const Poi = () => {
  const { instance } = useMsal();
  const [loading, setLoading] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);
  const { theme} = useTheme();

  const msalToken = localStorage.getItem("msal.accesstoken");
  const Token3DCE = localStorage.getItem("accesstokence");
  const sasToken = localStorage.getItem("sasToken");
  const navigate = useNavigate();
  const {
    unityProvider,
    isLoaded,
    loadingProgression,
    sendMessage,
    unload,
    addEventListener,
  } = useUnityContext({
    loaderUrl: "poieditor/Build/poieditor.loader.js",
    dataUrl: "poieditor/Build/poieditor.data",
    frameworkUrl: "poieditor/Build/poieditor.framework.js",
    codeUrl: "poieditor/Build/poieditor.wasm",
  });

  /* We'll round the loading progression to a whole number to represent the
   percentage of the Unity Application that has loaded. */
  const loadingPercentage = Math.round(loadingProgression * 100);
  /**
   * Function to get the cdf token
   */
  const getCdfToken = () => {
    const unityObj = {
      env: envConfig.env,
      middleware_base_url: envConfig.aotmwapi,
      access_token_3dce:
        envConfig.application_type === "couple" ? Token3DCE : "",
      msal_token: msalToken,
      cognite_ah_rootnode: envConfig.cognite_ah_rootnode,
      sas_token: sasToken,
      theme:theme
    };
    const unityJson = JSON.stringify(unityObj);
    console.log({ unityJson });
    sendMessage("HtmlUnityBridge", "OnConfigurationReceived", unityJson);
    setLoading(false);
  };
  /**
   * Function to manage handle click
   * @param {*} evt
   */
  const handleClick = async (evt) => {
    try {
      await unload();
      navigate(evt.detail.pathName, { replace: true });
    } catch (error) {
      console.log({ error });
    }
  };
  /**
   * React hook to handle side effect
   */
  useEffect(() => {
    if (isLoaded) {
      setLoading(true);
      getCdfToken();
    }
    addEventListener("raiseEventFromUnity", function (arg1, arg2) {
      if (arg1 === "Unauthorized") {
        console.log("AuthenticationFailLogOut");
        localStorage.removeItem("checkRole");
        const logoutRequest = {
          postLogoutRedirectUri: envConfig.redirectUri,
        };
        instance.logoutRedirect(logoutRequest);
      }
    });
    const handleWindowResize = () => {
      const widthreduced = (window.innerWidth / 100) * 5;
      setWindowWidth(window.innerWidth - widthreduced);
    };
    window.addEventListener("poiCheck", (evt) => {
      handleClick(evt);
    });
    window.addEventListener("/poi", (evt) => {
      handleClick(evt);
    });
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();
    
    const setWebGLTheme = () => {
      const theme=localStorage.getItem("TwinBuilder3DTheme");
    sendMessage("HtmlUnityBridge", "OnThemeChange",theme);
    };
    window.addEventListener("SetWebGLTheme", setWebGLTheme);
    /* cleanup */
    return () => {
      window.removeEventListener("resize", handleWindowResize);
      window.removeEventListener("SetWebGLTheme", setWebGLTheme);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded, loadingPercentage, addEventListener]);

  return (
    <div id="containerFixed">
      {!isLoaded ? (
        <>
          <Progress
            strokeColor={{
              "0%": "#108ee9",
              "100%": "#87d068",
            }}
            percent={loadingProgression * 100}
            showInfo={false}
          />
          <NavigationMessage></NavigationMessage>
        </>
      ) : null}
      <div id="unity-container" className="unity-desktop">
        <Unity
          unityProvider={unityProvider}
          style={{
            visibility: isLoaded ? "visible" : "hidden",
            width: `${windowWidth}px`,
            height: "calc(100vh - 85px)",
            marginTop: "-75px",
          }}
          tabIndex={1}
          devicePixelRatio={devicePixelRatio}
        />
      </div>
      {loading ? (
        <div className="centerPage">
          <div className="divAlignCenter">
            <Spin>
              <p>Loading</p>{" "}
            </Spin>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Poi;
